"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlotType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.SlotType = {
    VALID: 'VALID',
    ZOMBIES: 'ZOMBIES',
    ALL_VALID: 'ALL_VALID'
};
//# sourceMappingURL=slot-type.js.map